import { Component } from '@angular/core';

@Component({
    selector: 'cr-avid-disconnected',
    templateUrl: './disconnected.component.html',
    styleUrls: ['./disconnected.component.scss'],
})
export class DisconnectedComponent {}
